import PageWrapper from "app/components/page-wrapper/page-wrapper";
import ClaimMaintenance from "app/components/claim-maintenance/ClaimMaintenance";
import { FC } from "react";

const ClaimMaintenancePage: FC = () => {
  return (
    <PageWrapper>
      <ClaimMaintenance />
    </PageWrapper>
  );
};

export default ClaimMaintenancePage;
